import { useMemo } from 'react';
import { useGetCurrentPlanDetails } from './hooks/use-get-current-plan-details';
import { useGetPromotionalPlanDetails } from './hooks/use-get-promotional-plan-details';
import { useGetChangePlanHandler } from './hooks/use-get-change-plan-handler';

/** @typedef {import('./types').PlanDetails} PlanDetails */

/**
 * @typedef {object} IUseGetPromotionalMigrationPlan
 * @property {PlanDetails} currentPlanDetails
 * @property {boolean} isRequestingPlanChange
 * @property {Promise<void>} onChangePlan
 * @property {PlanDetails} promotionalPlanDetails
 */

/**
 * This hook encapsulates all of the business logic that is involved in calculating and composing the presentation values
 * @returns {IUseGetPromotionalMigrationPlan}
 */
export const useGetPromotionalMigrationPlan = () => {
  const currentPlanDetails = useGetCurrentPlanDetails();
  const promotionalPlanDetails = useGetPromotionalPlanDetails(currentPlanDetails);
  const { isRequestingPlanChange, onChangePlan } = useGetChangePlanHandler(promotionalPlanDetails);

  return useMemo(
    () => ({
      currentPlanDetails,
      isRequestingPlanChange,
      onChangePlan,
      promotionalPlanDetails,
    }),
    [currentPlanDetails, isRequestingPlanChange, onChangePlan, promotionalPlanDetails],
  );
};
